import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer" role="contentinfo" aria-label="Site Footer">
      <div className="site-footer__inner">
        <nav className="footer-links" aria-label="Footer Links">
          <Link to="/privacy-terms" className="footer-link-btn">
            Privacy policy &amp; Terms
          </Link>
          <Link to="/feedback" className="footer-link-btn">
            Feedback
          </Link>
          <Link to="/faq" className="footer-link-btn">
            FAQ
          </Link>
        </nav>
        <div className="footer-meta">
          &copy; FLW Connect Technologies Canada. Secure event innovation built with &#x2764;&#xFE0F; to
          make group choices easy
        </div>
      </div>
    </footer>
  );
}
